import React, {Component} from 'react';
import '../css/components/dateArrow.css';
import classNames from 'classnames'

interface DateArrowProps {
    className?: string;
}

class DateArrow extends Component<DateArrowProps> {

    constructor (props: DateArrowProps) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className={classNames("ss-date-arrow", this.props.className)}>
                <div className="arrow-top-half"/>
                <div className="arrow-bottom-half"/>
            </div>
        )
    }
}

export default DateArrow;
